import { Router } from 'vue-router'
import { useAuthStore } from '../stores/auth'

export function setupRouterGuards(router: Router) {
  router.beforeEach(async (to, _from, next) => {
    const authStore = useAuthStore()

    // Ensure auth is initialized
    if (!authStore.initialized) {
      await authStore.initialize()
    }

    // Protect dashboard routes - require authentication
    const protectedRoutes = ['/dashboard', '/agents', '/domains', '/tickets', '/settings', '/analytics', '/knowledge', '/tools', '/profile', '/security', '/billing']
    const isProtectedRoute = protectedRoutes.some(route => to.path.startsWith(route))

    if (isProtectedRoute) {
      if (!authStore.isAuthenticated) {
        // Not authenticated, redirect to login
        next('/login')
        return
      }
    }

    // Redirect authenticated users away from login/register pages
    if ((to.path === '/login' || to.path === '/register') && authStore.isAuthenticated) {
      next('/dashboard')
      return
    }

    // Allow access
    next()
  })
}
